import { Box, IconButton, Tooltip } from '@mui/material'
import React from 'react'
import {
  TreatmentGroupedAppointmentsComponent,
  TreatmentGroupedAppointmentsComponentViewModel,
} from './TreatmentGroupedAppointments'
import { Arrow } from './Arrow'
import { useScaleArrows } from './hooks/useScaleArrows'
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import {
  BetmenListHeader,
  BetmenListHeaderCell,
} from '../../../../../common/components'
import { TREATMENT_CALENDAR_WIDTH } from '../../../../../config'
import { useTreatmentPanelData } from './TreatmentPanelProvider'

interface AppointmentsWithArrowsProps {
  treatmentGroupedAppointmentsViewModel: TreatmentGroupedAppointmentsComponentViewModel
}
const AppointmentsWithArrows: React.FC<
  React.PropsWithChildren<AppointmentsWithArrowsProps>
> = ({ treatmentGroupedAppointmentsViewModel }) => {
  const { showArrows, toggleShowArrows } = useTreatmentPanelData()
  const { t } = useTranslation()
  const { scaleArrows } = useScaleArrows()
  const { arrowProps } = treatmentGroupedAppointmentsViewModel

  return (
    <Box display="flex" flexDirection="column" p={2} position="relative">
      {arrowProps.length > 0 && (
        <Box position="absolute" right="16px">
          <Tooltip
            placement="top"
            title={t('treatment:showHideArrows') as string}
          >
            <IconButton color="primary" size="large" onClick={toggleShowArrows}>
              {showArrows ? (
                <VisibilityOutlined fontSize={'large'} />
              ) : (
                <VisibilityOffOutlined fontSize={'large'} />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      )}

      <Box
        ml={`${TREATMENT_CALENDAR_WIDTH - 16}px`}
        mr={`${treatmentGroupedAppointmentsViewModel.widthOfArrows - 16}px`}
      >
        <BetmenListHeader>
          <BetmenListHeaderCell gridSize={1}>
            {t('treatment:item.type')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell gridSize={4}>
            {t('treatment:item.name')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell gridSize={3}>
            {t('treatment:item.doctor')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell gridSize={3}>
            {t('treatment:item.status')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell gridSize={1}></BetmenListHeaderCell>
        </BetmenListHeader>
      </Box>
      <TreatmentGroupedAppointmentsComponent
        vm={treatmentGroupedAppointmentsViewModel}
      />
      {showArrows &&
        arrowProps.map((arrowProp, i) => (
          <Arrow key={i} {...{ ...arrowProp, scale: scaleArrows }} />
        ))}
    </Box>
  )
}

export { AppointmentsWithArrows }
